import { useTranslation } from "@i18n";
var useValidate = function useValidate() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validatePhoneNumber = function validatePhoneNumber(number) {
    if (!number.startsWith("05")) return t("validation_mobile_number_start_05", {
      ns: "web_common"
    });
    if (number.length !== 10) return t("validation_mobile_number_consist_ten_digits", {
      ns: "web_common"
    });
    return "";
  };
  var validateName = function validateName(name) {
    if (name.trim().length < 5) return t("validation_name_less_5_characters", {
      ns: "web_common"
    });
    if (name.length < 3 || name.length > 25) return t("validation_number_characters_less_3_25", {
      ns: "web_common"
    });
    return "";
  };
  var validateCity = function validateCity(cityId) {
    if (!cityId) return t("validation_city_selected", {
      ns: "web_common"
    });
    return "";
  };
  var validateDate = function validateDate(date) {
    if (!date) return t("validation_date_selected", {
      ns: "web_common"
    });
    return "";
  };
  var validateNationalId = function validateNationalId(idNumber) {
    if (idNumber.trim().length !== 10) return t("validation_id_number_consist_10_digits", {
      ns: "web_common"
    });
    if (!idNumber.startsWith("1") && !idNumber.startsWith("2")) return t("validation_id_number_start_1_2", {
      ns: "web_common"
    });
  };
  var validateFamilyMembers = function validateFamilyMembers(val) {
    if (!val.trim()) return t("validation_field_mandatory", {
      ns: "web_common"
    });
    if (val.trim() >= 100) return t("validation_number_family_members_mustn_t", {
      ns: "web_common"
    });
    return "";
  };
  var validateEmail = function validateEmail(val) {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!val.match(emailRegex)) return t("validation_valid_email_address_entered", {
      ns: "web_common"
    });
    return "";
  };
  var validateRequired = function validateRequired(val, message) {
    if (!val.trim()) return t(message ? message : "هذا الحقل إلزامي", {
      ns: "web_common"
    });
    return "";
  };
  var validateMinValue = function validateMinValue(val, minVal, message) {
    if (val < minVal) return t(message ? message : "\u0627\u0644\u0642\u064A\u0645\u0629 \u064A\u062C\u0628 \u0627\u0646 \u0644\u0627 \u062A\u0642\u0644 \u0639\u0646 ".concat(minVal), {
      ns: "web_common"
    });
    return "";
  };
  var validateMaxValue = function validateMaxValue(val, maxVal, message) {
    if (val > maxVal) return t(message ? message : "\u0627\u0644\u0642\u064A\u0645\u0629 \u064A\u062C\u0628 \u0627\u0646 \u0644\u0627 \u062A\u0642\u0644 \u0639\u0646 ".concat(maxVal), {
      ns: "web_common"
    });
    return "";
  };
  return {
    validateName: validateName,
    validatePhoneNumber: validatePhoneNumber,
    validateCity: validateCity,
    validateDate: validateDate,
    validateNationalId: validateNationalId,
    validateRequired: validateRequired,
    validateFamilyMembers: validateFamilyMembers,
    validateEmail: validateEmail,
    validateMinValue: validateMinValue,
    validateMaxValue: validateMaxValue
  };
};
export default useValidate;